import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {updateProfileApi} from '../api/profile.api';

// Define a type for the slice state
interface formData {
  payload: {
    mobileNo: string;
    firstName: string;
    lastName: string;
    email: string;
    date_Of_Birth: string;
    gender: string;
  };
  accessToken: string;
}

interface UpdateProfileResponse {
  result: boolean;
  resultCode: string;
  message: string;
  updateMsg: string;
}

interface profileState {
  updateProfileResponse: any;
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: profileState = {
  updateProfileResponse: {},
  loading: false,
  error: '',
};

export const updateProfile = createAsyncThunk(
  'profile/updateProfile',
  async (parameters: any, thunkApi) => {
    return updateProfileApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const userProfileSlice = createSlice({
  name: 'userProfile',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetState: () => initialState,
    loading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      console.log(state.loading);
    },
  },
  extraReducers: builder => {
    builder.addCase(updateProfile.pending, state => {
      state.loading = true;
    });
    builder.addCase(updateProfile.fulfilled, (state, {payload}) => {
      state.updateProfileResponse = payload;
      state.loading = false;
    });
    builder.addCase(updateProfile.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
  },
});

export const {resetState} = userProfileSlice.actions;

// Other code such as selectors can use the imported `RootState` type
// export const profileData = (state: RootState): Profile[] =>
//   state.profileReducer.updateProfileResponse;
export const error = (state: RootState): string => state.profileReducer.error;
export const loading = (state: RootState): boolean =>
  state.profileReducer.loading;
export const updateProfileResponse = (
  state: RootState,
): UpdateProfileResponse => state.profileReducer.updateProfileResponse;

export default userProfileSlice.reducer;
